import type { Canvas } from "fabric";
import { useEffect } from "react";
import { useCanvasEventsListener } from "./useCanvasEventsListener.ts";

export const useCanvasAutoPersistence = ({
  fabricCanvas,
  onCanvasInit,
  onCanvasChange,
}: {
  fabricCanvas: Canvas | undefined;
  onCanvasInit: () => Promise<void> | void;
  onCanvasChange: () => Promise<void> | void;
}) => {
  useEffect(() => {
    if (!fabricCanvas) return;
    void onCanvasInit();
  }, [fabricCanvas, onCanvasInit]);

  useCanvasEventsListener({
    eventTypes: [
      "object:added",
      "object:removed",
      "object:modified",
      "object:moving",
      "object:scaling",
      "object:rotating",
      "object:skewing",
      "path:created",
      "canvas:cleared",
      "selection:cleared",
      "selection:updated",
      "object:visibility:changed",
      "background:color:changed",
      "canvas:size:changed",
      "layer:text:changed",
      "layer:text:selection:changed",
      "layer:shape:changed",
      "layer:rect:changed",
      "layer:line:changed",
      "layer:image:changed",
      "layer:image:contentUuid:changed",
      "layer:renamed",
    ],
    onEvent: () => {
      if (fabricCanvas) void onCanvasChange();
    },
    canvas: fabricCanvas,
  });
};
